import Items from '../components/Items';

const Content = () => {
  return <Items />;
}

export default Content;
